import { Navigation, Package } from "lucide-react";
import { PackagePhoto } from "./PackagePhoto";
import { bagHex, money, slotLabel } from "./cargoSlots";

export const NextParcelBar = ({ stop }) => {
  if (!stop) return null;
  const nav = stop.lat != null && stop.lng != null
    ? `https://www.google.com/maps/dir/?api=1&destination=${stop.lat},${stop.lng}`
    : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${stop.address_text}, ${stop.city || ""}`)}`;
  return (
    <section data-testid="next-parcel-bar" className="rounded-2xl bg-zinc-950 text-white p-4 flex gap-3 items-start shadow-xl">
      <div className="min-w-0 flex-1 space-y-2">
        <p className="text-[10px] font-mono uppercase tracking-widest text-orange-400">{`Następna paczka · #${stop.final_order}`}</p>
        <h2 data-testid="next-parcel-address" className="font-heading font-black text-2xl leading-tight break-words">{stop.address_text}</h2>
        {stop.cargo_slot ? (
          <p data-testid="next-parcel-slot" className="inline-flex items-center gap-2 rounded-xl bg-orange-500 text-white px-3 py-1.5 text-base font-black uppercase tracking-wide">
            {stop.cargo_bag ? <span className="w-4 h-4 rounded-full ring-2 ring-white/70" style={{ background: bagHex(stop.cargo_bag) }} /> : <Package className="w-4 h-4" />}
            {slotLabel(stop.cargo_slot, stop.cargo_bag)}
          </p>
        ) : <p className="text-xs text-zinc-400">Bez przypisanego miejsca na pace</p>}
        <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-zinc-300">
          {stop.client_name && <span>{stop.client_name}</span>}
          {stop.parcel_number && <span className="font-mono">#{stop.parcel_number}</span>}
          {(stop.time_from || stop.time_to) && <span>{`${stop.time_from || "…"}–${stop.time_to || "…"}`}</span>}
          {stop.cod_amount > 0 && <span className="font-bold text-emerald-400">{`Pobranie ${money(stop.cod_amount)} zł`}</span>}
        </div>
      </div>
      <div className="flex flex-col items-end gap-2 shrink-0">
        {stop.photo_id && <PackagePhoto id={stop.photo_id} className="w-20 h-20" testId="next-parcel-photo" />}
        <a href={nav} target="_blank" rel="noreferrer" data-testid="next-parcel-navigate" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-white text-zinc-900 text-xs font-black uppercase tracking-wider hover:bg-orange-100 transition-colors">
          <Navigation className="w-4 h-4" />Jedź
        </a>
      </div>
    </section>
  );
};
